import Vue from "vue";
import App from "./App.vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

// Import $tera / @iebh/Tera-fy global service
// NOTE: See bottom of file inside main async() init loop for when TeraFy actually boots
import TeraFy from "@iebh/tera-fy/dist/terafy.es2019.js"; // FIX: Use annoyingly old and specific version as Babel struggles with ESNEXT class imports
import TerafyVue from "@iebh/tera-fy/dist/plugin.vue2.es2019.js";

const terafy = new TeraFy()
	.set("devMode", process.env.VUE_APP_TERAFY_DEV == 1)
	.setIfDev("verbosity", process.env.VUE_APP_TERAFY_VERBOSITY || 1)
	.use(TerafyVue); // Add the Vue plugin

(async () => {
	const app = new Vue({
		render: h => h(App)
	});

	// Boot teraFy + require project + pull & subscribe to project data
	await terafy.init({
		app, // Provide app to bind against
		Vue // Provide the vue version to use
	});

	app.$mount("#app");
})();
